import React from 'react';
import { Tabs } from 'antd';
import { useLocation } from 'wouter';

const { TabPane } = Tabs;

const NavigationTabs = () => {
  const [location, setLocation] = useLocation();

  const getActiveKey = () => {
    if (location === '/controle' || location === '/') return 'controle';
    if (location === '/parametres') return 'parametres';
    if (location === '/plantations') return 'plantations';
    if (location === '/sondes') return 'sondes';
    return 'controle';
  };

  return (
    <Tabs activeKey={getActiveKey()} onChange={(key) => setLocation(`/${key}`)}>
      <TabPane tab="Contrôle" key="controle" />
      <TabPane tab="Paramètres" key="parametres" />
      <TabPane tab="Plantations" key="plantations" />
      <TabPane tab="Sondes" key="sondes" />
    </Tabs>
  );
};

export default NavigationTabs;